@let messgs = messages();

<div class="change-password">
  <div class="change-password__title component-title">
    {{ 'user-profile.security.changePassword.title' | translate }}
  </div>
  <div class="change-password__subtitle component-subtitle">
    {{ 'user-profile.security.changePassword.subtitle' | translate }}
  </div>
  <form class="change-password__form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="change-password__passwords">
      <div class="change-password__wrapper">
        <div class="change-password__password-title component-subtitle">
          {{ 'user-profile.security.changePassword.current' | translate }}
        </div>
        <div class="change-password__input-wrapper">
          <input
            name="currentPassword"
            [type]="isPasswordVisible[0] ? inputType.TEXT : inputType.PASSWORD"
            formControlName="currentPassword"
            class="change-password__input-wrapper__password-input"
            (keydown.space)="$event.preventDefault()"
            [class.error]="
              form.get('currentPassword')?.touched && form.get('currentPassword')?.errors
            "
            (input)="clearSubmissionMessages()"
          />
          <app-icon
            class="eye__icon"
            [icon]="isPasswordVisible[0] ? iconName.PASSWORD_EYE : iconName.PASSWORD_EYE_HIDE"
            (click)="togglePasswordVisibility(0)"
          />
        </div>
        @if (form.get('currentPassword')?.touched && form.get('currentPassword')?.errors) {
          <div class="change-password__error">
            @if (form.get('currentPassword')?.errors?.['required']) {
              {{ 'user-profile.security.changePassword.errors.emptyCurrentPassword' | translate }}
            }
          </div>
        } @else if (
          formSubmitted() && messgs.serverMessage === serverErrors.CURRENT_PASSWORD_INCORRECT
        ) {
          <div class="change-password__error">
            {{ messgs.serverMessage | translate }}
          </div>
        }
      </div>

      <div class="change-password__wrapper">
        <div class="change-password__password-title component-subtitle">
          {{ 'user-profile.security.changePassword.new' | translate }}
        </div>
        <div class="change-password__input-wrapper">
          <input
            name="newPassword"
            [type]="isPasswordVisible[1] ? inputType.TEXT : inputType.PASSWORD"
            formControlName="newPassword"
            class="change-password__input-wrapper__password-input"
            (keydown.space)="$event.preventDefault()"
            [class.error]="
              shouldShowErrors('newPassword') && form.get('newPassword')?.errors?.['required']
            "
            (input)="clearSubmissionMessages()"
          />
          <app-icon
            class="eye__icon"
            [icon]="isPasswordVisible[1] ? iconName.PASSWORD_EYE : iconName.PASSWORD_EYE_HIDE"
            (click)="togglePasswordVisibility(1)"
          />
        </div>
        @if (form.get('newPassword')?.touched && form.get('newPassword')?.errors) {
          <div class="change-password__error">
            @if (form.get('newPassword')?.errors?.['required']) {
              {{ 'user-profile.security.changePassword.errors.emptyNewPassword' | translate }}
            }
          </div>
        } @else if (formSubmitted()) {
          @if (form.hasError('sameAsCurrent')) {
            <div class="change-password__error">
              {{
                'user-profile.security.changePassword.errors.newPasswordSameAsCurrent' | translate
              }}
            </div>
          } @else if (messgs.serverMessage === serverErrors.NEW_PASSWORD_MATCH_PREVIOUS) {
            <div class="change-password__error">
              {{ messgs.serverMessage | translate }}
            </div>
          }
        }

        @if (shouldShowErrors('newPassword') && !form.get('newPassword')?.errors?.['required']) {
          <div class="change-password__password-errors">
            <div
              class="change-password__password-wrapper"
              [class]="getValidationClass('newPassword', 'length')"
            >
              <mat-icon
                class="change-password__error-sign"
                [fontIcon]="isValidationValid('newPassword', 'length') ? 'check' : 'close'"
              />
              <div class="change-password__error-message">
                {{ 'user-profile.security.changePassword.errors.atLeast' | translate }}
              </div>
            </div>
            <div
              class="change-password__password-wrapper"
              [class]="getValidationClass('newPassword', 'lowercaseLetter')"
            >
              <mat-icon
                class="change-password__error-sign"
                [fontIcon]="isValidationValid('newPassword', 'lowercaseLetter') ? 'check' : 'close'"
              />
              <div class="change-password__error-message">
                {{ 'user-profile.security.changePassword.errors.lowercaseLetter' | translate }}
              </div>
            </div>
            <div
              class="change-password__password-wrapper"
              [class]="getValidationClass('newPassword', 'capitalLetter')"
            >
              <mat-icon
                class="change-password__error-sign"
                [fontIcon]="isValidationValid('newPassword', 'capitalLetter') ? 'check' : 'close'"
              />
              <div class="change-password__error-message">
                {{ 'user-profile.security.changePassword.errors.capitalLetter' | translate }}
              </div>
            </div>
            <div
              class="change-password__password-wrapper"
              [class]="getValidationClass('newPassword', 'specialSymbol')"
            >
              <mat-icon
                class="change-password__error-sign"
                [fontIcon]="isValidationValid('newPassword', 'specialSymbol') ? 'check' : 'close'"
              />
              <div class="change-password__error-message">
                {{ 'user-profile.security.changePassword.errors.oneSpecial' | translate }}
              </div>
            </div>
            <div
              class="change-password__password-wrapper"
              [class]="getValidationClass('newPassword', 'digit')"
            >
              <mat-icon
                class="change-password__error-sign"
                [fontIcon]="isValidationValid('newPassword', 'digit') ? 'check' : 'close'"
              />
              <div class="change-password__error-message">
                {{ 'user-profile.security.changePassword.errors.oneDigit' | translate }}
              </div>
            </div>
          </div>
        }
      </div>

      <div class="change-password__wrapper">
        <div class="change-password__password-title component-subtitle">
          {{ 'user-profile.security.changePassword.confirm' | translate }}
        </div>
        <div class="change-password__input-wrapper">
          <input
            name="confirmPassword"
            [type]="isPasswordVisible[2] ? inputType.TEXT : inputType.PASSWORD"
            formControlName="confirmPassword"
            class="change-password__input-wrapper__password-input"
            (keydown.space)="$event.preventDefault()"
            [class.error]="
              form.get('confirmPassword')?.touched && form.get('confirmPassword')?.errors
            "
            (input)="clearSubmissionMessages()"
          />
          <app-icon
            class="eye__icon"
            [icon]="isPasswordVisible[2] ? iconName.PASSWORD_EYE : iconName.PASSWORD_EYE_HIDE"
            (click)="togglePasswordVisibility(2)"
          />
        </div>
        @if (form.get('confirmPassword')?.touched && form.get('confirmPassword')?.errors) {
          <div class="change-password__error">
            @if (form.get('confirmPassword')?.errors?.['required']) {
              {{ 'user-profile.security.changePassword.errors.emptyConfirmPassword' | translate }}
            }
          </div>
        } @else if (formSubmitted() && form.hasError('match')) {
          <div class="change-password__error">
            {{ 'user-profile.security.changePassword.errors.passwordMatch' | translate }}
          </div>
        }
      </div>
    </div>

    <div class="change-password__btn-wrapper">
      <button type="submit" class="change-password__submit btn-primary">
        {{ 'user-profile.security.changePassword.button' | translate }}
      </button>
    </div>
  </form>
</div>
<div class="two-factor-authentication">
  <app-two-factor-toggle />
</div>
